/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-27 09:46:28
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-08-06 10:05:19
 * @FilePath: /goldenSalesMobile/src/api/goods.js
 * @Description: 商品列表相关api
 */
import { $http, requestOfPost } from '@/utils/http'
import { requestOfGet } from '../utils/http'
const baseUrl = 'wechath5/zh-cn/v1/'
// 提成记录
export function getPersumestatistics(param) {
  return requestOfPost(`${baseUrl}report/gv5/jishi/persumestatistics`, param)
}

// 做钟记录
export function getClockstatistics(param) {
  return requestOfPost(`${baseUrl}report/gv5/jishi/clockstatistics`, param)
}

// 查询技师
export function getJishicode(param) {
  return requestOfGet(`${baseUrl}jishi/jishicode/${param.VpnId}`)
}
// 查询技师班次
export function getJishiClassList(param) {
  return requestOfGet(`${baseUrl}jishi/class/${param.VpnId}`)
}
// 上下班
export function jishiDuty(param){
  return $http(`${baseUrl}jishi/duty`, param);
}

export function postParameterSetting(param){
  return $http(`${baseUrl}parameter/setting`, param);
}

export function getUserInfo(param){
  return requestOfGet(`${baseUrl}customer/profile/need`, param);
}

